module.exports = __webpack_public_path__ + "static-v-shop/1785501885960/img/logo_maestro.ced7dab5.png";